// @flow
import React from 'react';
import cn from 'classnames';

import css from './Banner.module.scss';

const MOBILE_ID = 'div-gpt-ad-1678117736535-0';

type Props = {
	adsCustomParam: string,
};

function Banner({ adsCustomParam }: Props) {
	const [isMobile, setIsMobile] = React.useState<any>(undefined);
	const [isClosed, setIsClosed] = React.useState(false);
	const [isRendered, setIsRendered] = React.useState(false);

	const onCloseBtnClick = () => {
		setIsClosed(true);
	};

	React.useEffect(() => {
		const isMob = window.matchMedia('(max-width: 768px)');
		setIsMobile(isMob.matches);
		let timeout;
		if (isMob) {
			timeout = setTimeout(() => {
				setIsClosed(true);
			}, 15000);
		}
		return () => {
			clearTimeout(timeout);
		};
	}, []);

	React.useEffect(() => {
		const controller = new AbortController();

		if (isMobile !== undefined) {
			const container = document.querySelector(`#${MOBILE_ID}`);
			const { googletag } = window;
			const topWindow = window.top;
			if (googletag && container) {
				// When close clicked.
				topWindow.DFP = topWindow.DFP || {};
				topWindow.DFP.onMaavaronClose = function() {
					setIsClosed(true);
				};
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				window.addEventListener(
					'DFPDecision',
					(e: CustomEvent) => {
						const [, , isClose] = e.detail;
						setIsClosed(isClose);
					},
					{ signal: controller.signal }
				);

				googletag.cmd.push(function() {
					googletag
						.defineSlot('/242748299/mako/list/maavaron', [320, 410], MOBILE_ID)
						.addService(googletag.pubads());
					// set custom parm to ads url
					googletag.pubads().setTargeting('MAKOPAGE', adsCustomParam);
					googletag.pubads().enableSingleRequest();
					googletag.pubads().addEventListener('slotRenderEnded', () => {
						console.info('slotRenderEnded');
						setIsRendered(true);
					});
					googletag.enableServices();
				});
				googletag.cmd.push(function() {
					googletag.display(MOBILE_ID);
				});
			}
		}

		return () => {
			controller.abort();
		};
	}, [isMobile]);

	return isClosed === false ? (
		<div className={cn(css.bannerWrap, isRendered && css.rendered)}>
			<div className={css.banner}>
				<button className={css.closeBtn} onClick={onCloseBtnClick} type="button" />
				<div id={MOBILE_ID} style={{ minWidth: '320px', minHeight: '410px' }}></div>
			</div>
		</div>
	) : null;
}

export default Banner;
